import styled from '@emotion/styled';
import * as ErrorMessage from '../../shared/components/error/ErrorMessage';
import { StyledSearchIcon } from './SearchEmptyState';
import { Css } from '../../../ui';
import { Color } from '../../../styles/Color';

export function SearchNoResults() {
	return (
		<Wrapper>
			<ErrorMessage.Root>
				<StyledSearchIcon />
				<ErrorMessage.Title>No results found</ErrorMessage.Title>
				<ErrorMessage.Description>
					Please check your provided details and change your search input.
				</ErrorMessage.Description>
			</ErrorMessage.Root>
		</Wrapper>
	);
}

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	gap: ${Css.pxToRem(16)};
	margin-top: ${Css.pxToRem(100)};

	${ErrorMessage.Root} {
		padding: 0 !important;
	}

	${ErrorMessage.Title} {
		margin-top: ${Css.pxToRem(16)};
	}

	${ErrorMessage.Description} {
		font-size: ${Css.pxToRem(16)};
		font-weight: 300;
		color: ${Color.Neutral6};
		margin-top: ${Css.pxToRem(8)};
	}
`;
